import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && user) navigate("/admin", { replace: true });
    }, [user, loading, navigate]);

    const handleSignIn = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/admin/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen bg-[#F2E8D5] flex items-center justify-center p-6" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-brand-cream rounded-3xl border border-stone-200 shadow-xl p-8 md:p-10">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full border-2 border-brand-purple flex items-center justify-center">
                        <ShieldCheck size={20} className="text-brand-purple" />
                    </div>
                    <div>
                        <div className="text-xs tracking-[0.3em] uppercase text-stone-500">Admin</div>
                        <div className="font-serif text-xl">Poppa &amp; Gigi&apos;s <span className="font-accent text-brand-purple">Promise</span></div>
                    </div>
                </div>
                <h1 className="mt-7 font-serif text-3xl">Sign in</h1>
                <p className="mt-2 text-stone-600 text-sm">Restricted to authorized admins only. Sign in with your authorized Google account.</p>

                {loading ? (
                    <div className="mt-8 flex items-center gap-2 text-stone-500">
                        <Loader2 className="animate-spin" size={18} /> Checking session...
                    </div>
                ) : (
                    <button
                        onClick={handleSignIn}
                        data-testid="admin-login-google"
                        className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-stone-900 text-white px-6 py-3 rounded-full hover:bg-stone-800 transition"
                    >
                        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
                            <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.49h4.84c-.21 1.12-.84 2.07-1.79 2.71v2.25h2.9c1.7-1.56 2.69-3.86 2.69-6.61z"/>
                            <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.9-2.25c-.81.54-1.83.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.33A9 9 0 0 0 9 18z"/>
                            <path fill="#FBBC05" d="M3.95 10.71A5.41 5.41 0 0 1 3.66 9c0-.59.1-1.17.29-1.71V4.96H.96A9.01 9.01 0 0 0 0 9c0 1.45.35 2.83.96 4.04l2.99-2.33z"/>
                            <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.34l2.58-2.58A9 9 0 0 0 .96 4.96l2.99 2.33C4.66 5.17 6.65 3.58 9 3.58z"/>
                        </svg>
                        Continue with Google
                    </button>
                )}

                <div className="mt-6 text-xs text-stone-500 leading-relaxed">
                    Not an admin? <Link to="/home" className="text-brand-purple underline">Back to the site →</Link>
                </div>
            </div>
        </div>
    );
}
